import React, { useEffect, useState } from "react";
import { AiOutlineLike } from "react-icons/ai";
const ReviewSection = () => {
  const [helpFul, setHelpFul] = useState(true);
  const [learnMore, setLearnMore] = useState(false);
  const [moreText, setMoreText] = useState(true);
  const [helpFullNumber, setHelpFullNumber] = useState(1);
  const defaultHelpNum = 1;
  const likedReview = () => {
    helpFul
      ? setHelpFullNumber(helpFullNumber + 1)
      : setHelpFullNumber(defaultHelpNum);
    setHelpFul(!helpFul);
  };
  const learnMoreFunc = () => {
    setLearnMore(!learnMore);
    setMoreText(!moreText);
  };
  return (
    <div>
      <div className="review-section">
        <div className="review-and-date p-3">
          <div className="d-flex justify-between my-3">
            <ul className="sidebarReviews d-flex flex-start align-center">
              <div
                className="reviewsStars d-flex"
                style={{
                  backgroundImage: "url('../assets/images/review-star.svg')",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "1rem",
                  width: "6rem",
                }}
              ></div>
            </ul>
            <span className="ml-1 review-numbers">03/4/2020</span>
          </div>
        </div>

        <div className="reviewer-message">
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
            Consequuntur fugiat porro voluptates nam sit illo mollitia veniam
            deserunt optio? Sit tenetur reprehenderit recusandae nisi officiis
            odio et inventore quia dolores temporibus{" "}
            {learnMore
              ? "tempore nihil a unde eaque magni sed asperiores aspernatur, deserunt itaque quae."
              : ""}
            &nbsp;{" "}
            <span
              className="underLined c-pointer underline-hovered moreOrLess-text"
              onClick={learnMoreFunc}
            >
              {moreText ? "..More" : "Less"}
            </span>
          </p>
        </div>

        <div className="reviewer-img-container">
          <div className="reviewer-img">
            <img
              src="https://sundialinsider.s3.us-east-2.amazonaws.com/500cart-sidebar.jpg"
              width="100%"
              alt=""
            />
          </div>
          <h4 className="reviewer-name"> Holly from Bremen, KY </h4>
          <span className="verify-text">VERIFIED BUYER </span>

          <div className="mt-2 helpFull-btn">
            <label
              onClick={likedReview}
              className={
                helpFul
                  ? "like-lable"
                  : "like-lable bg-default default-hover review-helpFull"
              }
            >
              <div className="d-flex justify-between align-center">
                <AiOutlineLike className="helpFull-linke" />
                <span>Helpful</span>
                <span>{helpFullNumber}</span>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewSection;
